import React from "react";
import { motion } from "framer-motion";

function Navbar({ activeTab, setActiveTab }) {
  const tabVariants = {
    active: { scale: 1.1 },
    inactive: { scale: 1 },
  };

  return (
    <div className="navbar justify-between font-poppins">
      <motion.p
        className={`btn btn-ghost p-0 sm:px-5 px-1 ${
          activeTab === "About"
            ? "text-purple-500 sm:text-xl"
            : "text-white sm:text-lg text-xs"
        }`}
        variants={tabVariants}
        whileHover="active"
        whileTap="active"
        onClick={() => setActiveTab("About")}
      >
        About
      </motion.p>
      <motion.p
        className={`btn btn-ghost p-0 sm:px-5 px-1 ${
          activeTab === "Resume"
            ? "text-purple-500 sm:text-xl"
            : "text-white sm:text-lg text-xs"
        }`}
        variants={tabVariants}
        whileHover="active"
        whileTap="active"
        onClick={() => setActiveTab("Resume")}
      >
        Resume
      </motion.p>
      <motion.p
        className={`btn btn-ghost p-0 sm:px-5 px-1 ${
          activeTab === "Projects"
            ? "text-purple-500 sm:text-xl"
            : "text-white sm:text-lg text-xs"
        }`}
        variants={tabVariants}
        whileHover="active"
        whileTap="active"
        onClick={() => setActiveTab("Projects")}
      >
        Projects
      </motion.p>
      <motion.p
        className={`btn btn-ghost p-0 sm:px-5 px-1 ${
          activeTab === "Blogs"
            ? "text-purple-500 sm:text-xl"
            : "text-white sm:text-lg text-xs"
        }`}
        variants={tabVariants}
        whileHover="active"
        whileTap="active"
        onClick={() => setActiveTab("Blogs")}
      >
        Blogs
      </motion.p>
      <motion.p
        className={`btn btn-ghost sm:px-5 px-1 ${
          activeTab === "Contact"
            ? "text-purple-500 sm:text-xl"
            : "text-white sm:text-lg text-xs"
        }`}
        variants={tabVariants}
        whileHover="active"
        whileTap="active"
        onClick={() => setActiveTab("Contact")}
      >
        Contact
      </motion.p>
    </div>
  );
}

export default Navbar;
